import { NgxUiLoaderConfig } from 'ngx-ui-loader';

export const SpinnerConfig: NgxUiLoaderConfig = {
    fgsType: 'ball-spin',
    overlayColor: 'rgba(255,255,255,0.5)',
    fgsSize: 40,
    hasProgressBar: false
}
export const TOASTR_CNST = {
    closeButton: true,
    timeOut: 3000,
    extendedTimeOut: 2000
  };